import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <p>© {new Date().getFullYear()} Berkinson</p>
      <p>18160 Cottonwood Rd PMB 534, Sunriver, OR 97707</p>
      <p>
        <a href="/terms">Terms</a> | <a href="/privacy-policy">Privacy</a>
      </p>
    </footer>
  );
}
